
export const sFechaPublicacion = '2024-06-20T12:44:30.1322659-06:00';
export const sVersion = 'vSL2C0.1.06201244';
            